export default __webpack_public_path__ + "static/media/8.e4fe8f6c.jpeg";